import { html, LitElement } from 'lit';
import { GzFormFieldWebComponent } from '../../../../ui/gzForm/formField';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { query, state, property } from 'lit/decorators.js';
import { GzRadioGroupWebComponent } from '../../../../ui/gzRadio';
import { LicenseRenderers } from '../../../../company/common/licenseRenderers/LicenseRenderers';
import { FeatureFlag } from '@nirvana/shared/constants';
import { styles } from '../view/styles';
import { RequiredValidator } from '../../../../ui/gzForm/validators/required.validator';
import { translateFn } from '../../../../utils/translator.helper';
import { AvailableBundlesForAffectedDescendants } from '../../../types/Bundles';
import { Observable } from 'rxjs';

export class LicenseMonthlyAvailableBundlesForAffectedDescendantsFormWebComponent extends LitElement {
  @state()
  private formGroup: FormGroup = new FormGroup({});

  @query('#leftover-bundles-to-delegate-form-field')
  leftOverBundlesToDelegateFormField: GzFormFieldWebComponent<GzRadioGroupWebComponent, string | number>;

  @query('#product-options-radio-group')
  productOptionsRadioGroup: GzRadioGroupWebComponent;

  @property({ type: Object, attribute: true, reflect: true })
  availableBundles: AvailableBundlesForAffectedDescendants | undefined;

  @property({ type: Array, attribute: true, reflect: true })
  public selectedOption: FeatureFlag | undefined;

  static get styles() {
    return styles;
  }

  connectedCallback(): void {
    super.connectedCallback();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
  }

  public get value(): FeatureFlag {
    return this.formGroup?.value.selectedBundle as FeatureFlag;
  }

  public get valid(): Observable<boolean> {
    return this.formGroup.valid$;
  }

  public selectOption(featureFlag: FeatureFlag): void {
    this.productOptionsRadioGroup.selectOption(featureFlag);
  }

  async firstUpdated(changedProperties): Promise<void> {
    super.firstUpdated(changedProperties);
    await this.buildFormGroup();
    this.dispatchEvent(new CustomEvent('connected', { bubbles: true, composed: true }));
  }

  public getFormGroup(): FormGroup {
    return this.formGroup;
  }

  private buildFormGroup(): void {
    this.leftOverBundlesToDelegateFormField.Validators = [RequiredValidator(translateFn('Select a product'))];
    this.formGroup = FormGroup.build({
      selectedBundle: this.leftOverBundlesToDelegateFormField,
    });
  }

  shouldUpdate(): boolean {
    return this.availableBundles !== undefined;
  }

  render() {
    if (!this.availableBundles) {
      return;
    }

    return html`
      <div id="wrapper">
        <gz-form-field id="leftover-bundles-to-delegate-form-field" required>
          <gz-radio-group
            gz-form-input
            id="product-options-radio-group"
            groupName="product-options-radio-group"
            selectedOption="${Object.keys(this.availableBundles).length === 1
              ? Object.values(this.availableBundles)[0]
              : ''}"
          >
            ${this.renderRadioList(this.availableBundles)}
          </gz-radio-group>
        </gz-form-field>
      </div>
    `;
  }

  private renderRadioList(bundles) {
    return html`${Object.keys(bundles).map(index => {
      return html`
        <gz-radio
          .id="bundle-${index}"
          .value="${bundles[index]}"
          .label="${LicenseRenderers.getTranslatedBundleName(Number(index))}"
        >
        </gz-radio>
      `;
    })}`;
  }
}
